import React from "react";
import SmallCard from "../../../components/page/SmallCard";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";

function DashboardSmallCards({ dashboardDados }) {
  return (
    <div className="row">
      <SmallCard
        title="Contas pagas no mês"
        value={Format.formataValor(dashboardDados?.contasPagas ?? 0)}
        icon="bx bx-check-circle"
      />
      <SmallCard
        title="Contas a pagar no mês"
        value={Format.formataValor(dashboardDados?.contasAPagar ?? 0)}
        icon="bx bx-hourglass"
      />
      <SmallCard
        title="NFS-e emitidas no mês"
        value={dashboardDados?.nfseEmitidas?.qnt_mes_atual ?? 0}
        icon="bx bx-package"
      />
    </div>
  );
}

DashboardSmallCards.propTypes = {
  dashboardDados: PropTypes.object.isRequired,
};

export default DashboardSmallCards;
